module.exports = {
  sign_in: {
    main_heading: "admin.sign_in_page_heading",
    sub_heading: "admin.sign_in_to_your_account_sub_heading",
    email_placeholder: "admin.sign_in_email_placeholder",
    password_placeholder: "admin.sign_in_password_placeholder",
    loading_btn_text: "admin.loading_btn_text",
    login_btn_text: "admin.login_btn_text",
    forgot_password_link_text: "admin.forgot_password_link_text",
    incorrect_credentials_error: "admin.sign_in_incorrect_credentials_error",
    general_error: "admin.sign_in_general_error",
  },
  forgot_password: {
    main_heading: "admin.forgot_password_heading_text",
    sub_heading: "admin.forgot_password_sub_heading_text",
    email_placeholder: "admin.forgot_password_email_placeholder",
    send_btn_text: "admin.forgot_password_send_btn_text",
    cancel_btn_text: "admin.forgot_password_cancel_btn_text",
  },
  google_mfa_verification: {
    main_heading: "admin.google_mfa_verification_heading_text",
    sub_heading: "admin.google_mfa_verification_sub_heading_text",
    otp_placeholder: "admin.google_mfa_verification_otp_placeholder",
    send_btn_text: "admin.google_mfa_verification_send_btn_text",
    cancel_btn_text: "admin.google_mfa_verification_cancel_btn_text",
  },
  sms_mfa_verification: {
    main_heading: "admin.sms_mfa_verification_heading_text",
    sub_heading: "admin.sms_mfa_verification_sub_heading_text",
    otp_placeholder: "admin.sms_mfa_verification_otp_placeholder",
    send_btn_text: "admin.sms_mfa_verification_send_btn_text",
    cancel_btn_text: "admin.sms_mfa_verification_cancel_btn_text",
  },
  otp_verification: {
    main_heading: "admin.otp_verification_heading_text",
    sub_heading: "admin.otp_verification_sub_heading_text",
    otp_placeholder: "admin.otp_verification_otp_placeholder",
    not_received_otp_text: "admin.otp_verification_not_received_text",
    resend_otp_text: "admin.otp_verification_resend_otp_text",
    verify_otp_btn_text: "admin.otp_verification_verify_btn_text",
    cancel_btn_text: "admin.otp_verification_cancel_btn_text",
    resend_timer_error: "admin.otp_verification_otp_resend_after_time_frame"
  },
  verify_otp: {
    main_heading: "admin.otp_verification_heading_text",
    sub_heading: "admin.verify_otp_sub_heading_text",
    otp_placeholder: "admin.otp_verification_otp_placeholder",
    verify_otp_btn_text: "admin.otp_verification_verify_btn_text",
    cancel_btn_text: "admin.otp_verification_cancel_btn_text",
    sending_text: "admin.verify_otp_sending_text",
    resend_otp_in_timer: "admin.verify_otp_resend_otp_in_timer",
    didnt_receive_otp_resend: "admin.verify_otp_didnt_receive_otp_resend",
    session_expired_error: "admin.verify_otp_session_expired_error",
    email_not_found_error: "admin.verify_otp_email_not_found_error",
    wait_before_resend_error: "admin.verify_otp_wait_before_resend_error",
    otp_verified_success: "admin.verify_otp_verified_success",
    invalid_server_response: "admin.verify_otp_invalid_server_response"
  },
  reset_password: {
    main_heading: "admin.reset_password_heading_text",
    sub_heading: "admin.reset_password_sub_heading_text",
    new_password_placeholder: "admin.reset_password_new_password_placeholder",
    confirm_password_placeholder: "admin.reset_password_confirm_password_placeholder",
    submit_btn_text: "admin.reset_password_reset_btn_text",
    cancel_btn_text: "admin.reset_password_cancel_btn_text",
    session_expired_error: "admin.reset_password_session_expired_error",
    password_reset_success: "admin.reset_password_success_message",
    failed_to_reset_error: "admin.reset_password_failed_error"
  },
  sub_admin_reset_password: {
    step1_title: "admin.sub_admin_reset_password_title",
    step1_subtitle: "admin.sub_admin_reset_password_enter_email",
    step2_title: "admin.sub_admin_verify_otp_title",
    step2_subtitle: "admin.sub_admin_enter_otp_sent_to",
    step3_title: "admin.sub_admin_set_new_password_title",
    step3_subtitle: "admin.sub_admin_enter_new_password",
    send_otp_btn: "admin.sub_admin_send_otp_btn",
    verify_otp_btn: "admin.sub_admin_verify_otp_btn",
    update_password_btn: "admin.sub_admin_update_password_btn",
    otp_placeholder: "admin.sub_admin_otp_placeholder",
    email_placeholder: "admin.sub_admin_email_placeholder",
  },
  password_setup: {
    main_heading: "admin.password_setup_main_heading",
    sub_heading: "admin.password_setup_sub_heading",
    new_password_placeholder: "admin.password_setup_new_password_placeholder",
    confirm_password_placeholder: "admin.password_setup_confirm_password_placeholder",
    setup_btn_text: "admin.password_setup_btn_text",
    invalid_link_title: "admin.password_setup_invalid_link_title",
    invalid_link_message: "admin.password_setup_invalid_link_message",
    request_new_link_btn: "admin.password_setup_request_new_link_btn",
  },
  change_password: {
    main_heading: "admin.change_password_title",
    old_password_label: "admin.profile_old_password_label",
    old_password_placeholder: "admin.profile_old_password_placeholder",
    new_password_label: "admin.profile_new_password_label",
    new_password_placeholder: "admin.profile_new_password_placeholder",
    confirm_password_label: "admin.profile_confirm_password_label",
    confirm_password_placeholder:
      "admin.reset_password_confirm_password_placeholder",
    submit_btn_text: "admin.change_password_submit_button",
    cancel_button: 'admin.change_password_cancel_button',
    failed_to_change_error: "admin.change_password_failed_error",
    old_new_password_same: "admin.change_password_old_new_same_error",
    validation: {
      old_password: {
        required: "admin.old_password_is_required",
      },
      new_password: {
        required: "admin.new_password_is_required",
        pattern: "admin.change_password_invalid",
      },
      confirm_password: {
        required: "admin.confirm_password_is_required",
        same_password: "admin.confirm_password_new_password_must_match",
      },
    }
  },
  edit_profile: {
    main_heading: "admin.admin_edit_profile_title",
    invalid_file_format: "admin.invalid_upload_format_of_image",
    size_of_image: 'admin.invalid_upload_format_size_of_image',
    first_name_label: "admin.edit_profile_first_name_label",
    first_name_placeholder: "admin.enter_first_name",
    last_name_label: "admin.edit_profile_last_name_label",
    last_name_placeholder: "admin.enter_last_name",
    email_label: "admin.edit_profile_email_label",
    email_placeholder: "admin.edit_profile_enter_email_label",
    contact_number_label: "admin.edit_profile_contact_number_label",
    contact_number_placeholder: "admin.edit_profile_enter_contact_number_label",
    submit_btn_text: "admin.edit_profile_submit_button",
    cancel_button: 'admin.edit_profile_cancel_button',
    update_email: {
      email_heading: "admin.edit_email_model",
      email_label: "admin.edit_profile_email_change_label",
      email_placeholder: "admin.edit_profile_enter_email_label",
      cancel_button: "admin.add_email_cancel_button",
      submit_btn: "admin.add_email_submit_button",
      validation: {
        email: {
          required: "admin.edit_profile_email_required",
          pattern: "admin.edit_profile_invalid_email_format",
        },
      }
    },
    otp_verify: {
      main_heading: "admin.edit_profile_otp_verify",
      otp_label: "admin.edit_profile_otp_label",
      otp_placeholder: "admin.edit_profile_enter_otp_label",
      otp_resend_text: "admin.otpverification_resend_link_header_text",
      otp_resend_link: "admin.otpverification_resend_link",
      cancel_button: "admin.otp_verify_cancel_button",
      submit_btn: "admin.otp_verify_submit_button",
      resend_otp_after_some_time: 'admin.you_can_resend_after_30_second',
      validation: {
        otp: {
          pattern: "admin.edit_profile_otp_must_be_6_digit",
          required: "admin.edit_profile_otp_required",
        },
      }
    },
    validation: {
      first_name: {
        required: "admin.edit_profile_first_name_required",
      },
      last_name: {
        required: "admin.edit_profile_last_name_required",
      },
      contact_number: {
        pattern: "admin.invalid_phone_number_format",
        required: "admin.edit_profile_contact_number_required",
      },
    },
  },
  mfa_settings: {
    main_heading: "admin.mfa_settings_heading_text",
    google_auth_mfa_label: "admin.mfa_settings_google_auth_mfa_label",
    sms_auth_mfa_label: "admin.mfa_settings_sms_auth_mfa_label",
    secret_key_placeholder: "admin.mfa_settings_secret_key_placeholder",
    mfa_otp_placeholder: "admin.mfa_settings_mfa_otp_placeholder",
    google_mfa_question: {
      enable_message: "admin.mfa_settings_are_sure_want_to_enable",
      disable_message: "admin.mfa_settings_are_sure_want_to_disable"
    },
    sms_mfa_question: {
      enable_message: "admin.mfa_settings_are_sure_want_to_enable",
      disable_message: "admin.mfa_settings_are_sure_want_to_disable"
    },
    yes_btn_text: "admin.mfa_settings_yes_btn_text",
    no_button_text: "admin.mfa_settings_no_button_text",
    close_btn_text: "admin.mfa_settings_close_btn_text",
    verify_button_text: "admin.mfa_settings_verify_button_text",
    resend_otp_after_some_time: "admin.mfa_settings_you_can_resend_after_30_second",
    mfaModal: {
      heading: "admin.mfa_settings_modal_main_heading",
      mainContent: "admin.mfa_settings_modal_main_content",
      footerContent: "admin.mfa_settings_modal_bottom_content",
    }
  }
};
